import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';

import {DevicesTableModalComponent} from '../devices-table-modal/devices-table-modal.component';
import {ModalVisibilityService} from '../../../../services/modal-visibility.service';
import {ProjectsListItemModel} from '../../../../models/projects-list-item.model';
import {SmallTextInfoModalComponent} from '../../../small-text-info-modal/small-text-info-modal.component';
import {Subscription} from 'rxjs';
import {MyProjectsTableRowActionEnum} from '../../../../enums/my-project-table-row-action.enum';
import {ActionsMenuComponent} from '../../tables_shared_components/actions-menu/actions-menu.component';
import {UserTypeEnum} from '../../../../enums/user-type.enum';
import {ProjectStatusEnum} from '../../../../enums/project-status.enum';
import {ModalDynamicV3Service} from '../../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';

@Component({
    selector: 'app-projects-table-row',
    templateUrl: './projects-table-row.component.html',
    styleUrls: ['./projects-table-row.component.scss']
})
export class ProjectsTableRowComponent implements OnInit, OnDestroy {
    // tslint:disable:max-line-length
    private closeMenuTimer: any;
    private openDeviceTabModalTimer: any;
    private openProgressBarInfoModalTimer: any;

    @ViewChild('actionMenu', {static: true}) actionMenu: ActionsMenuComponent;


    @Input() public project: ProjectsListItemModel;

    @Output() public projectRowActionsMenuClicked = new EventEmitter<{
        projectListItem: ProjectsListItemModel,
        actionId: MyProjectsTableRowActionEnum
    }>();

    public isActionsMenuVisible = false;
    private deviceTabModalDialogRef: IModalDialogV3;
    private progressBarInfoDialogRef: any;

    private modalVisibilitySub: Subscription;


    // public priceApprovalStatusEnum = ProjectStatusDetailsEnum;
    public projectStatusEnum = ProjectStatusEnum;


    private merchantActionMenuItems = [
        {label: 'Projekt bearbeiten', faName: 'edit', actionId: MyProjectsTableRowActionEnum.EDIT},
        {label: 'Projekt kopieren', faName: 'copy', actionId: MyProjectsTableRowActionEnum.COPY},
        {label: 'Änderungshistorie', faName: 'history', actionId: MyProjectsTableRowActionEnum.HISTORY},
        {label: 'Projekt löschen', faName: 'times', actionId: MyProjectsTableRowActionEnum.DELETE},
    ];

    private internalUserActionMenuItems = [
        {label: 'Projekt bearbeiten', faName: 'edit', actionId: MyProjectsTableRowActionEnum.EDIT},
        {label: 'Gerät Angebot', faName: 'external-link', actionId: MyProjectsTableRowActionEnum.DOWNLOAD_OFFER_PDF},

        {label: 'Änderungshistorie', faName: 'history', actionId: MyProjectsTableRowActionEnum.HISTORY},

        // be careful, the TCO Kalkulation item has to be on index=4, otherwise the method getActionMenuItems will change name of other item instead of this one
        // there is not enough time for test and do it in the right way, because in this case the item some time do not throw mouse enter event
        {
            label: 'TCO Kalkulation',
            faName: 'calculator',
            actionId: MyProjectsTableRowActionEnum.TCO_CALCULATION
        }
    ];

    private internalPriceApprovalPreviewMenuItems = [
        {label: 'TCO Kalkulation', faName: 'calculator', actionId: MyProjectsTableRowActionEnum.TCO_CALCULATION},  // added for [BROT-1157] ( so now it is the same as internalPriceApprovalMenuItems)
        {label: 'Änderungshistorie', faName: 'history', actionId: MyProjectsTableRowActionEnum.HISTORY},
    ];

    private internalPriceApprovalMenuItems = [
        {label: 'TCO Kalkulation', faName: 'calculator', actionId: MyProjectsTableRowActionEnum.TCO_CALCULATION},
        {label: 'Änderungshistorie', faName: 'history', actionId: MyProjectsTableRowActionEnum.HISTORY},
    ];


    constructor(
        private modalDynamicV3Service: ModalDynamicV3Service,
        private modalVisibilityService: ModalVisibilityService,
    ) {
    }

    public ngOnInit() {
        this.modalVisibilitySub = this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$.subscribe(_ => {
                this.closeActionsMenu();
            }
        );
    }

    public isDisabled(): boolean {
        return false;
    }

    public onActionsBtnClicked() {
        if (this.isActionsMenuVisible) {
            this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();
        } else {
            this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();
            this.isActionsMenuVisible = true;
            this.actionMenu.open();
        }

    }


    public closeActionsMenu() {
        this.isActionsMenuVisible = false;
        this.actionMenu.close();
    }

    public onActionsMenuItemClicked(actionId: MyProjectsTableRowActionEnum) {
        this.isActionsMenuVisible = false;
        this.projectRowActionsMenuClicked.next({projectListItem: this.project, actionId: actionId});
    }


    public setCloseMenuTimer() {
        if (this.isActionsMenuVisible) {
            this.closeMenuTimer = setTimeout(_ => this.closeActionsMenu(), 300);
        }
    }

    public removeCloseMenuTimer() {
        if (this.closeMenuTimer) {
            clearTimeout(this.closeMenuTimer);
        }
    }


    public onDeviceAmountMouseEnter(anchor: HTMLElement) {
        if (this.project.requestedProductsTotalCount && this.project.requestedProductsTotalCount > 0) {
            if (this.project?.devices?.length) {
                this.openDeviceTabModalTimer = setTimeout(_ => this.openDevicesTabModal(anchor), 300);
            } else {
                console.error('project devices do not match with requestedProductsTotalCount, ' +
                    'project model is not consistent, (hover fnc. was not executed)', this.project);
            }
        }
    }

    public onDeviceAmountMouseLeave() {
        if (this.openDeviceTabModalTimer) {
            clearTimeout(this.openDeviceTabModalTimer);
        }
    }

    public openDevicesTabModal(anchor: HTMLElement) {


        this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();

        const deltaX = -169;
        const deltaY = 20;


        // helps avoid to display dialog out of the screen
        const expectedDialogHeight = 270;
        const marginBottom = 10;


        const top = Math.floor(+anchor.getBoundingClientRect().top) + deltaY;
        const left = Math.floor(+anchor.getBoundingClientRect().right) + deltaX;

        this.deviceTabModalDialogRef = this.modalDynamicV3Service
            .open(DevicesTableModalComponent, {
                model: {
                    project: this.project,
                    top: top,
                    left: left,
                    marginBottom: 10
                }
            }, true);


        this.modalVisibilitySub = this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$.subscribe(_ => {

            if (this.deviceTabModalDialogRef) {
                this.deviceTabModalDialogRef.close();
                this.modalVisibilitySub.unsubscribe();
                this.deviceTabModalDialogRef = undefined;
                this.modalVisibilitySub = undefined;
            }
        });

    }


    public onProgressBarMouseEnter(anchor: HTMLElement, deltaX = 0) {
        let message;
        let title;


        if (this.project.isLocked) {

            if (this.project.lockedByUserType === UserTypeEnum[UserTypeEnum.BROTHER_EMPLOYEE]) {
                message = 'Projekt gesperrt – Projekt gesperrt durch Brother Innendienst';
            } else {
                message = 'Projekt gesperrt – Projekt gesperrt durch Fachhändler: ' + this.project.lockedBy;
            }

        } else {

            switch (ProjectStatusEnum[this.project.status]) {
                case ProjectStatusEnum.DRAFT:
                    message = 'Anfrage wurde noch nicht an Brother übermittelt.';
                    break;
                case ProjectStatusEnum.REQUEST:
                // message = 'Ihr Angebot wird schnellstmöglich bearbeitet.';
                // break;
                case ProjectStatusEnum.IN_PROCESS:
                    message = 'Ihr Angebot wird schnellstmöglich bearbeitet.';
                    break;
                case ProjectStatusEnum.QUOTE_SENT:
                    message = 'Die Angebotsinformation wurde übermittelt. ' +
                        'Das konkrete Angebot erhalten Sie in Kürze von uns, bzw. von dem von Ihnen gewählten Distributor.';
                    break;
                case ProjectStatusEnum.QUOTE_SENT_MANUALLY:
                    message = 'Die Angebotsinformation wurde übermittelt. ' +
                        'Das konkrete Angebot erhalten Sie in Kürze von uns, bzw. von dem von Ihnen gewählten Distributor.';
                    break;
                case ProjectStatusEnum.REJECTED:
                    message = 'Bitte nutzen Sie Ihre Standardkonditionen.';
                    break;
                case ProjectStatusEnum.PROJECT_WON:
                    message = 'Projekt gewonnen';
                    break;
                default:
                    console.warn('unrecognized status value: ' + this.project.status);
            }
        }


        if (message || title) {
            this.openProgressBarInfoModalTimer =
                setTimeout(_ => this.openProgressBarInfoModal(anchor, title, [message], deltaX), 300);
        }

    }

    public onProgressBarMouseLeave() {
        this.closeProgressBarInfoDialog();
    }

    private closeProgressBarInfoDialog() {
        if (this.openProgressBarInfoModalTimer) {
            clearTimeout(this.openProgressBarInfoModalTimer);
        }
        if (this.progressBarInfoDialogRef) {
            this.progressBarInfoDialogRef.close();
            this.progressBarInfoDialogRef = undefined;
        }
    }

    public openProgressBarInfoModal(anchor: HTMLElement, title: string, messages: string[], deltaX: number) {


        this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();

        // const deltaX = -400;
        const deltaY = -5;

        const top = Math.floor(+anchor.getBoundingClientRect().top) + deltaY;
        const left = Math.floor(+anchor.getBoundingClientRect().right) + deltaX;

        this.progressBarInfoDialogRef = this.modalDynamicV3Service
            .open(SmallTextInfoModalComponent, {
                model: {
                    title: title,
                    messages: messages,
                    top: top,
                    left: left,
                    showCloseBtn: false,
                    minHeight: 40,
                    closeEvent: this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$
                }
            }, true);


        // this.modalVisibilitySub = this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$.subscribe(_ => {
        //
        //     if (this.progressBarInfoDialogRef) {
        //         this.progressBarInfoDialogRef.close();
        //         this.modalVisibilitySub.unsubscribe();
        //         this.progressBarInfoDialogRef = undefined;
        //         this.modalVisibilitySub = undefined;
        //     }
        // });

    }


    public getProjectStatusIcon(project: ProjectsListItemModel): string {
        // only draft icon is displayed for merchant user
        if (ProjectStatusEnum[project.status] === ProjectStatusEnum.DRAFT) {
            return './assets/img/icon_warning.svg';
        }
        return null;
    }

    public isInternalUser() {
        return false;
    }


    public onProjectNameClicked() {
        this.projectRowActionsMenuClicked.next({
            projectListItem: this.project,
            actionId: MyProjectsTableRowActionEnum.PROJECT_NAME_LINK_CLICKED
        });
    }


    public getActionMenuItems(): { label: string, faName: string, actionId: MyProjectsTableRowActionEnum }[] {
        return this.merchantActionMenuItems;
    }


    public onLockInfoMouseEnter(lockAnchor: HTMLDivElement) {
        let messages: string[];

        if (this.project.lockedByUserType === UserTypeEnum[UserTypeEnum.BROTHER_EMPLOYEE]) {
            messages = ['Projekt gesperrt – Projekt gesperrt durch Brother Innendienst'];
        } else {
            messages = ['Projekt gesperrt – Projekt gesperrt durch Fachhändler: ' + this.project.lockedBy];
        }


        this.openProgressBarInfoModalTimer =
            setTimeout(_ => this.openProgressBarInfoModal(lockAnchor, null, messages, -296), 300);
    }

    public onLockInfoMouseLeave() {
        this.closeProgressBarInfoDialog();
    }

    public ngOnDestroy(): void {
        if (this.modalVisibilitySub) {
            this.modalVisibilitySub.unsubscribe();
        }
    }

    public isActionBntDisabled(): boolean {
        return this.project.isLocked;
    }

    public showLockInfo(project: ProjectsListItemModel): boolean {
        return !project.isLocked && !!project.lockedBy;
    }
}
